export default "__VITE_ASSET__BfI1i2WE__"